/* eslint-disable no-console */
import { toast } from "react-hot-toast";
import { log, supabase } from ".";

export const saveOportunidadBTL = async (oportunidad) => {
  try {
    const data = await supabase.insert("sales_btl", oportunidad);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    console.error("saveOportunidadBTL error:", error);
    log.error("saveOportunidadBTL", error);
    toast.error("Error al guardar la oportunidad BTL");
    throw error;
  }
};
